import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';
import { RequestsService } from "src/app/core/services/requests.service";

@Injectable({
  providedIn: 'root'
})
export class SimuladorService {
  //ENDPOINT = "http://127.0.0.1:8000/jamaradmin/simulaciontasas";
  requestsService: any;
  ENDPOINT = getEndpoint('simulador_tasas');
  constructor(private _http: HttpClient, private _http2: RequestsService) { }

  async tasas(company: string) {
    const url = `${this.ENDPOINT}/tasas/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async tasasPreferencial(company: string) {
    const url = `${this.ENDPOINT}/tasasPreferencia/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async politicaPreferencial(company: string) {
    const url = `${this.ENDPOINT}/politicaPreferencial/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async actualizarPreferencial(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/actualizarPreferencial/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }
  async simuladorPreferencial(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/simuladorPreferencial/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }
  async tnm(company: string) {
    const url = `${this.ENDPOINT}/tnm/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async seg(company: string) {
    const url = `${this.ENDPOINT}/seg/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async estado(company: string) {
    const url = `${this.ENDPOINT}/estado/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async comision(company: string) {
    const url = `${this.ENDPOINT}/comision/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }
  async cobranza(company: string) {
    const url = `${this.ENDPOINT}/cobranza/${company}`;
    const res = this._http.get(url).toPromise();
    return res
  }

  async ActualizarTasa(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/updatetasa/${company}`;
    const body = {
      usuario: usuario,
      payload: { valores: payload }
    };
    return await this._http2.postLikeJSON(url, body);
  }

  async ActualizarSeguro(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/updateseguro/${company}`;
    const body = {
      usuario: usuario,
      payload: { valores: payload }
    };
    return await this._http2.postLikeJSON(url, body);
  }

  async ActualizarEstado(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/updatestado/${company}`;
    const body = {
      usuario: usuario,
      payload: { valores: payload }
    };
    return await this._http2.postLikeJSON(url, body);
  }

  async ActualizarComision(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/updatecomision/${company}`;
    const body = {
      usuario: usuario,
      payload: { valores: payload }
    };
    return await this._http2.postLikeJSON(url, body);
  }

  async ActualizarCobranza(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/updatecobranza/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }

  async Simulador(company: string, payload: any): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/simulacion/${company}`;
    return await this._http2.postLikeJSON(url, payload);
  }

  async CrearTasa(company: string, payload: any, usuario?: string): Promise<BasicResponse> {
    const url = `${this.ENDPOINT}/creartasa/${company}`;
    const body = {
      payload: {
        plazo:    payload.plazo,
        tasa:     payload.tasa,
        seguro:   payload.seguro,
        comision: payload.comision,
        cobranza: payload.cobranza,
        estado:   payload.estado
      },
      usuario: usuario
    };
    return await this._http2.postLikeJSON(url, body);
  }

  async plazosDisponibles(company: string) {
    const url = `${this.ENDPOINT}/plazosDisponibles/${company}`;
    const res = this._http.get(url).toPromise();
    return res;
  }
  
}